import { useState, useRef, Fragment } from "react";
import { FORM_STATUS_LABELS } from "../../../util/constants";
import { MuiIcons, Mui } from "@osu/react-ui";
import StatusAlert from "./StatusAlert";
import useFormStatusChanger from "../../hooks/useForm/StatusChanger";
import NextWidget from "../Router/NextWidget";

const {
  Radio,
  FormLabel,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Dialog,
} = Mui;


export default function ChangeStatus({ size, variant, sx }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const formStatusHookProps = useFormStatusChanger();
  const { canChangeTo,
    isLoading,
    isSuccess,
    isError,
    changeStatus,
    status,
    showConfirmation
   } = formStatusHookProps;

  const [statusValue, setStatusValue] = useState(status);
   
  const handleMenuItemClick = async (event, newStatus) => {
    setStatusValue(newStatus)
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const menuId = "change-status-menu";
  if (!canChangeTo?.length) {
    return false;
  }
  const options = canChangeTo

  const onSubmit = (event, a, b) => {
    changeStatus(statusValue)
  }

  const changeStatusBtnProps = {}
  if(isLoading) {
    changeStatusBtnProps.disabled = true
    changeStatusBtnProps.startIcon = <MuiIcons.Refresh />
  } else if (statusValue === status) {
    changeStatusBtnProps.disabled = true
  }
  const isSuccessfulAPIUpdate = isSuccess && !!statusValue && !!showConfirmation?.to && !!showConfirmation?.from

  return (
    <Fragment>
      <Mui.Button
        ref={anchorRef}
        size={size}
        variant={variant}
        sx={sx}
        endIcon={<MuiIcons.Expand color="inherit" />}
        aria-controls={open ? menuId : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-label="Status Change Menu"
        aria-haspopup="menu"
        onClick={handleToggle}
      >
         Change Status
      </Mui.Button>
      <Dialog
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
      >
        <Mui.DialogTitle component="h2">
          Change Form Status
        </Mui.DialogTitle>
        <Mui.DialogContent id={menuId} sx={{ p: 3 }}>
          <StatusAlert             
            loading={isLoading}
            error={isError}
            success={isSuccessfulAPIUpdate}
            {...showConfirmation || {}}
          />
          <FormControl>
            <FormLabel id={menuId + "-label"}>Change Status</FormLabel>
            <RadioGroup
              aria-labelledby={menuId + "-label"}
              value={statusValue}
              onChange={handleMenuItemClick}
              name="radio-buttons-group"
            >
              {options.map((key, index) => {
                let label = FORM_STATUS_LABELS?.[key] || key;
                const isCurrent = key === status
                const disabled = isLoading || isCurrent
                 if(isCurrent && !isLoading) {
                    label += ` (Current Status)`
                  }
                return (
                  <Fragment key={index + key + "change-status-item"}>
                    <FormControlLabel
                      value={key}
                      control={<Radio />}
                      label={label}
                      disabled={disabled}
                    />
                  </Fragment>
                );
              })}
            </RadioGroup>
          </FormControl>
        </Mui.DialogContent>
        <Mui.Divider />
        <Mui.DialogActions>
          <Mui.Button sx={{
            mr: 'auto'
          }} onClick={handleClose} color="primary">
            Close
          </Mui.Button>
          <Mui.Button {...changeStatusBtnProps} variant="contained" onClick={onSubmit} color="primary">
            Change Status
          </Mui.Button>
          {!!isSuccessfulAPIUpdate && <NextWidget size="md" color="primary" />}
        </Mui.DialogActions>
      </Dialog>
    </Fragment>
  );
}
